export class ExtractionError extends Error {
  public code?: string;

  constructor(message: string = '', code?: string) {
    super(message);
    this.name = 'ExtractionError';
    this.message = message;
    this.code = code;
  }
}

export const isExtractionError = (error: Error): boolean => error instanceof ExtractionError;
